 
require('dotenv').config()

const environment = {
    // url_api_infra_service:"http://localhost:5000/"
    // url_api_infra_service:"http://icfc.guiadocondutor.com.br:5000/"
    url_api_infra_service: process.env.REACT_APP_URL_API_INFRA_SERVICE,
    // url_api_producao_service: "http://localhost:5000/"

    url_api_producao_service:process.env.REACT_APP_URL_API_PRODUCAO_SERVICE

}
 export default environment;
